require('./catalog-view.component.scss');

class CatalogViewController {
  constructor(CatalogNodeDragService, $element) {
    this.drag = CatalogNodeDragService;
  }
}

export const CatalogViewComponent = {
  template: require('./catalog-view.component.html'),
  bindings: {
    model: '<',
    filter: '<',
    filters: '<',
  },
  controller: CatalogViewController,
   transclude : true
};



// WEBPACK FOOTER //
// ./src/view/catalog/catalog-view.component.js